/**
 * Created by Josef Jurca on 03/09/2018.
 */

import {
    ActionTypes,
    ConnectStates
} from '../../actions/pages/connect';

const defaultState = {
        status: ConnectStates.INITIAL,
        error: null
    },

    /**
     * Sets connect code state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setConnectState = function (state, action) {

        return {
            ...state,
            status: action.state
        };
    },

    /**
     * Sets connect code error.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setConnectError = function (state, action) {

        return {
            ...state,
            error: action.error
        };
    },

    /**
     * Returns the settings state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    settings = function (state = defaultState, action) {

        switch (action.type) {

            case ActionTypes.SET_CONNECT_STATE:
                return (state = setConnectState(state, action));

            case ActionTypes.SET_CONNECT_ERROR:
                return (state = setConnectError(state, action));

            default:
                return state;
        }
    };

export default settings;


// WEBPACK FOOTER //
// ./src/js/store/reducers/pages/connect.js